'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('directory-list', {
      url: '/directory/:name',
      template: '<directory-list></directory-list>',
      authenticate: true
    })
    .state('directory-list-public', {
      url: '/public/directory/:name',
      template: '<directory-list public="true"></directory-list>'
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/directory/list/directory-list.routes.js